import React, { useState, useRef, useEffect } from "react";
import html2canvas from "html2canvas";

import design1 from "../assets/design1.png";
import design2 from "../assets/design2.png";
import design3 from "../assets/design3.png";
import logo from "../assets/logo.png";
import backgroundImage from "../assets/backgroundImage.png";

const Home = () => {
  const [selectedDesign, setSelectedDesign] = useState(null);
  const [selectedMessage, setSelectedMessage] = useState("");
  const [userName, setUserName] = useState("");
  const cardRef = useRef(null);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 600);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);
  
  const designs = [
    { id: 1, src: design1 },
    { id: 2, src: design2 },
    { id: 3, src: design3 },
  ];

  const messages = [
    "تقبل الله منا ومنكم صالح الأعمال\n وجعل عيدكم فرحًا وسرورًا وكل عام وأنتم بخير",
    "كل عام وأنتم بخير عيد فطر مبارك\n أعاده الله علينا وعليكم بالخير والرضا والغفران",
    "عاد عيدكم وكل عام والفرح يملأ قلوبكم",
  ];

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 600);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const downloadCard = () => {
    if (!selectedDesign || !selectedMessage || !userName) {
      alert("يرجى اختيار التصميم والرسالة وإدخال الاسم!");
      return;
    }

    html2canvas(cardRef.current, { scale: 2 }).then((canvas) => {
      const link = document.createElement("a");
      link.href = canvas.toDataURL("image/png");
      link.download = "greeting_card.png";
      link.click();
    });
  };

  return (
    <div
      style={{
        textAlign: "center",
        fontFamily: "Siwa, sans-serif",
        position: "relative",
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        minHeight: "100vh",
        padding: "20px",
        boxSizing: "border-box",
      }}
    >
      <img
        src={logo}
        alt="شعار الموقع"
        style={{
          position: "absolute",
          top: "10px",
          left: "10px",
          width: "150px",
          height: "auto",
          transition: "transform 0.3s",
          cursor: "pointer",
        }}
        onMouseEnter={(e) => (e.target.style.transform = "scale(1.1)")}
        onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
      />

      <h2 style={{ color: "white", marginTop: "200px" }}>اختر تصميم البطاقة</h2>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "10px",
          flexWrap: "wrap",
          marginBottom: "20px",
        }}
      >
        {designs.map((design) => (
          <img
            key={design.id}
            src={design.src}
            alt={`تصميم ${design.id}`}
            style={{
              width: isMobile ? "30%" : "150px",
              border:
                selectedDesign === design.id
                  ? "3px solid #007bff"
                  : "1px solid #ddd",
              cursor: "pointer",
              borderRadius: "10px",
            }}
            onClick={() => setSelectedDesign(design.id)}
          />
        ))}
      </div>

      <h2 style={{ color: "white" }}>اختر عبارة التهنئة</h2>
      <div style={{ marginBottom: "20px" }}>
        {messages.map((msg, index) => (
          <label
            key={index}
            style={{
              display: "block",
              margin: "10px auto",
              padding: "10px",
              backgroundColor: selectedMessage === msg ? "#007bff" : "#fff",
              color: selectedMessage === msg ? "#fff" : "#333",
              borderRadius: "10px",
              width: "90%",
              maxWidth: "500px",
              cursor: "pointer",
            }}
          >
            <input
              type="radio"
              name="message"
              value={msg}
              checked={selectedMessage === msg}
              onChange={() => setSelectedMessage(msg)}
              style={{ margin: "0 10px" }}
            />
            {msg}
          </label>
        ))}
      </div>

      <h2 style={{ color: "white" }}>أدخل اسمك</h2>
      <input
        value={userName}
        onChange={(e) => setUserName(e.target.value)}
        placeholder="اكتب اسمك هنا..."
        style={{
          padding: "10px",
          borderRadius: "5px",
          border: "none",
          width: "90%",
          maxWidth: "400px",
          marginBottom: "20px",
        }}
      />

      <h2 style={{ color: "white" }}>معاينة البطاقة</h2>
      <div
  ref={cardRef}
  style={{
    width: "100%",
    maxWidth: "500px",
    margin: "20px auto",
    position: "relative",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    borderRadius: "15px",
    overflow: "hidden",
    boxSizing: "border-box",
    display: "inline-block",
  }}
>
  {selectedDesign && (
    <img
      src={designs.find((d) => d.id === selectedDesign)?.src}
      alt="معاينة البطاقة"
      style={{
        width: "100%",
        height: "auto",
        display: "block",
      }}
    />
  )}

  {/* النص والاسم فوق الصورة */}
  <div
    style={{
      position: "absolute",
      bottom: "0",
      left: "0",
      width: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: isMobile ? "10px" : "20px",
      boxSizing: "border-box",
    }}
  >
    {/* عبارة التهنئة */}
    <div
      style={{
        color: selectedDesign === 3 ? "#8dc444" : "#ffffff",
        fontSize: selectedDesign === 3 
  ? (isMobile ? "16px" : "1.2rem") 
  : (isMobile ? "16px" : "1.2rem"),
        fontWeight: "bold",
        textAlign: "center",
        lineHeight: "1.7",
        whiteSpace: "pre-line",
        marginBottom: "5px",
        textShadow: "0 1px 3px rgba(255,255,255,0.8)",
      }}
    >
      {selectedMessage || "اختر عبارة التهنئة"}
    </div>

    {/* اسم المستخدم */}
    <div
      style={{
        backgroundColor: "#ffffff",
        color: selectedDesign === 3 ? "#f2800e" : "#18256e",
        padding: "6px 15px",
        borderRadius: "20px",
        boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
        fontSize: isMobile ? "12px" : "0.9rem",
        whiteSpace: "nowrap",
      }}
    >
      {userName ? `${userName}` : "اكتب اسمك هنا"}
    </div>
  </div>
</div>

      <button
        onClick={downloadCard}
        style={{
          padding: "12px 25px",
          fontSize: "1rem",
          backgroundColor: "#283a93",
          color: "#fff",
          border: "none",
          borderRadius: "10px",
          cursor: "pointer",
        }}
      >
        تحميل البطاقة 📥
      </button>
    </div>
  );
};

export default Home;
